module.exports = __webpack_public_path__ + "static/elephant-2-ead49ba64f569b74d35ddfd07354ff53.jpg";